import React from "react";
import styled from "styled-components";
import colors from "../styles/colors";
import Wrapper from "../components/styled/wrapper";
import toHTML from "../helpers/toHtml";

import Biznode from "../img/aaa.svg";
import ISO from "../img/ISO.png";

export default ({ footer }) => {
  return (
    <>
      <Footer>
        <FooterWrapper>
          <div dangerouslySetInnerHTML={{ __html: toHTML(footer.col1) }} />
          <div dangerouslySetInnerHTML={{ __html: toHTML(footer.col2) }} />
          <div dangerouslySetInnerHTML={{ __html: toHTML(footer.col3) }} />
        </FooterWrapper>
      </Footer>
      <Certifications>
        <img src={Biznode} alt="" />
        <img src={ISO} alt="" />
      </Certifications>
    </>
  );
};

const Footer = styled.footer`
  padding: 6rem 0;
  background-color: ${colors.offWhite07};
`;

const FooterWrapper = styled(Wrapper)`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  max-width: 80rem;

  @media (min-width: 700px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 5rem;
  }
`;

const Certifications = styled(Wrapper)`
  max-width: 60rem;
  padding: 2rem 0;
  display: flex;
  flex-grow: 0;
  justify-content: space-around;
  align-items: center;
  > img {
    flex:0;
    width: 10rem;
    height: 3rem;
    max-width: 30%;
  }
`;